<script>
    import { createEventDispatcher } from 'svelte'

    import CloseButton from './CloseButton.svelte'
    import TryAgainButton from './TryAgainButton.svelte'

    import { modals } from '../../logic'

    export let data = {
        modalId: ''
    }
    export let ending

    $: showModal = currentModal || ending

    $: currentModal = data.modalId && modals.find((m) => data.modalId === m.id)
    //$: currentModal = data.modalId && modals.find((m) => 'everythingIsOk' === m.id)
    

    const dispatch = createEventDispatcher()
</script>

<svelte:window on:click={() => {
    if (showModal){
        dispatch('close')
    }
}}/>

{#if showModal}
    <div class="reaction-wrapper" on:click={() => dispatch('close')}>
        <div class="modal-wrapper"
            class:managerDoesntRemember={currentModal.id === 'managerDoesntRemember'}
            class:notActualGraph={currentModal.id === 'notActualGraph'}
            class:runOverAll={currentModal.id === 'runOverAll'}
            class:youAreLucky={currentModal.id === 'youAreLucky'}
            class:hrOneEye={currentModal.id === 'hrOneEye'}
            class:bossIsAway={currentModal.id === 'bossIsAway'}
            class:foundAnotherManager={currentModal.id === 'foundAnotherManager'}
            class:hrFoundFault={currentModal.id === 'hrFoundFault'}
            class:unpaidLeave={currentModal.id === 'unpaidLeave'}
            class:unpaidLeaveIsOk={currentModal.id === 'unpaidLeaveIsOk'}
            class:youAreTired={currentModal.id === 'youAreTired'}
            class:datesDoNotOverlap={currentModal.id === 'datesDoNotOverlap'}
            class:bitterExperience={currentModal.id === 'bitterExperience'}
            class:everythingIsOk={currentModal.id === 'everythingIsOk'}
            class:lose={ending && ending.type === 'lose'}
            class:win={ending && ending.type === 'win'}
            on:click={(e) => e.stopPropagation()}
        >
            <div class="close-button" on:click={() => dispatch('close')}>
                {#if !ending}
                    <CloseButton />
                {:else}
                    <TryAgainButton />
                {/if}
            </div>
            
            <div class="modal-inner">
                {@html (!ending ? currentModal.title : ending.message)}
            </div>

            {#if ending && ending.type === 'win'}
                <div class="win-icons">
                    <span />
                    <span />
                    <span />
                    <span />
                    <span />
                    <span />
                    <span />
                </div>
            {/if}
        </div>

        <div class="mobile-button" on:click={() => dispatch('close')}>
            <div>{!ending ? 'Продолжить' : 'Начать заново'} </div>
        </div>
    </div>
{/if}

<style lang="scss">
    .reaction-wrapper {
        position: absolute;
        left: 32px;
        top: 32px;
        width: calc(100% - (36px * 2));
        height: calc(100% - (32px * 2));
        background: rgba(115, 115, 115, 0.9);
        border-radius: 7px;

        .mobile-button {
            display: none;
        }

        .modal-wrapper {
            position: absolute;
            left: 234px;
            top: 143px;
            display: flex;
            align-items: center;
            justify-content: center;
            width: calc(100% - (234px * 2));
            height: calc(100% - (143px * 2));
            background: #FFFFFF;
            border: 2px solid #FE8324;
            box-sizing: border-box;
            box-shadow: 0px 4px 9px rgba(0, 0, 0, 0.1);
            border-radius: 10px;

            .close-button {
                position: absolute;
                top: 24px;
                right: 24px;
                cursor: pointer;
            }

            .modal-inner {
                font-size: 16px;
                line-height: 26px;
                text-align: center;
                color: #000000;
                margin: 0 100px;
                z-index: 100;
            }

            &:before,
            &:after {
                content: '';
                position: absolute;
                background-repeat: no-repeat;
                background-size: contain;
                background-position: center;
            }

            &.lose,
            &.win {
                min-height: 420px;
            }

            &.lose {
                &:before {
                    background-image: url('../img/icons/cross-two.png');
                    top: -20px;
                    left: -30px;
                    width: 200px;
                    height: 200px;
                }

                &:after {
                    background-image: url('../img/icons/cross.png');
                    right: -30px;
                    bottom: 150px;
                    width: 100px;
                    height: 100px;
                }
            }

            &.win {
                .win-icons {
                    span {
                        position: absolute;
                        background-repeat: no-repeat;
                        background-size: contain;
                        background-position: center;
                        background-image: url('../img/icons/star.png');

                        &:nth-child(1){
                            top: 65px;
                            left: 35px;
                            width: 80px;
                            height: 80px;
                            transform: rotate(-3.64deg);
                        }

                        &:nth-child(2){
                            top: 0;
                            left: 100px;
                            width: 100px;
                            height: 100px;
                            transform: rotate(-13.94deg);
                        }

                        &:nth-child(3){
                            top: -40px;
                            right: 200px;
                            width: 90px;
                            height: 90px;
                        }

                        &:nth-child(4){
                            top: 35px;
                            right: 125px;
                            width: 70px;
                            height: 70px;
                        }

                        &:nth-child(5){
                            top: -25px;
                            right: 75px;
                            width: 70px;
                            height: 70px;
                            transform: rotate(27.81deg);
                        }

                        &:nth-child(6),
                        &:nth-child(7) {
                            background-image: url('../img/icons/medal.png');
                        }

                        &:nth-child(6){
                            bottom: -50px;
                            right: 50px;
                            width: 110px;
                            height: 110px;
                            transform: rotate(23.56deg);
                        }

                        &:nth-child(7){
                            bottom: 10px;
                            right: -50px;
                            width: 130px;
                            height: 130px;
                            transform: rotate(-24.53deg);
                        }
                    }
                }
            }

            &.managerDoesntRemember {
                &:before {
                    background-image: url('../img/icons/calendar.png');
                    top: -20px;
                    right: 125px;
                    width: 150px;
                    height: 150px;
                    transform: rotate(13.2deg);
                }

                &:after {
                    background-image: url('../img/icons/calendar.png');
                    left: -10px;
                    bottom: 75px;
                    width: 100px;
                    height: 100px;
                    transform: rotate(-21.81deg);
                }
            }

            &.notActualGraph {
                &:before {
                    background-image: url('../img/icons/one-gear.png');
                    top: -30px;
                    right: 175px;
                    width: 100px;
                    height: 100px;
                    transform: rotate(-12.51deg);
                }

                &:after {
                    background-image: url('../img/icons/gears.png');
                    left: -35px;
                    bottom: 30px;
                    width: 150px;
                    height: 150px;
                }
            }

            &.runOverAll {
                &:before {
                    background-image: url('../img/icons/chat.png');
                    left: 15px;
                    top: -20px;
                    width: 150px;
                    height: 150px;
                }
                &:after {
                    background-image: url('../img/icons/one-chat.png');
                    right: -30px;
                    bottom: 75px;
                    width: 95px;
                    height: 95px;
                    transform: rotate(20.06deg);
                }
            }

            &.youAreLucky {
                &:before {
                    background-image: url('../img/icons/handshake.png');
                    bottom: -10px;
                    right: -25px;
                    width: 150px;
                    height: 150px;
                    transform: rotate(-21.2deg);
                }
            }

            &.hrOneEye {
                &:before {
                    background-image: url('../img/icons/checklist.png');
                    bottom: -25px;
                    right: -10px;
                    width: 200px;
                    height: 200px;
                    transform: rotate(6.75deg);
                }

                &:after {
                    background-image: url('../img/icons/checklist.png');
                    top: 30px;
                    left: -10px;
                    width: 130px;
                    height: 130px;
                    transform: matrix(-0.99, 0.15, 0.15, 0.99, 0, 0);
                }
            }

            &.bossIsAway {
                &:before {
                    background-image: url('../img/icons/diplomat.png');
                    right: 70px;
                    bottom: -30px;
                    width: 170px;
                    height: 170px;
                    transform: rotate(-32.73deg);
                }

                &:after {
                    background-image: url('../img/icons/diplomat.png');
                    top: 70px;
                    left: -30px;
                    width: 100px;
                    height: 100px;
                    transform: rotate(18.25deg);
                }
            }

            &.foundAnotherManager {
                &:before {
                    background-image: url('../img/icons/target.png');
                    top: 50px;
                    left: -20px;
                    width: 175px;
                    height: 175px;
                    transform: matrix(-1, -0.04, -0.04, 1, 0, 0);
                }

                &:after {
                    background-image: url('../img/icons/target.png');
                    right: -10px;
                    bottom: 40px;
                    width: 125px;
                    height: 125px;
                    transform: rotate(-2.41deg);
                }
            }

            &.hrFoundFault {
                &:before {
                    background-image: url('../img/icons/loudspeaker.png');
                    right: -50px;
                    bottom: 10px;
                    width: 250px;
                    height: 250px;
                }

                &:after {
                    background-image: url('../img/icons/loudspeaker.png');
                    left: -40px;
                    top: 20px;
                    width: 200px;
                    height: 200px;
                    transform: rotate(-180deg);
                }
            }

            &.unpaidLeave {
                &:before {
                    background-image: url('../img/icons/list-cross.png');
                    left: -10px;
                    bottom: -10px;
                    width: 165px;
                    height: 165px;
                    transform: rotate(-28.1deg);
                }

                &:after {
                    background-image: url('../img/icons/cross.png');
                    top: 140px;
                    right: -30px;
                    width: 83px;
                    height: 83px;
                }
            }

            &.unpaidLeaveIsOk {
                &:before {
                    background-image: url('../img/icons/list-arrows.png');
                    top: -10px;
                    right: 170px;
                    width: 100px;
                    height: 100px;
                    transform: rotate(13.19deg);
                }

                &:after {
                    background-image: url('../img/icons/list-arrows.png');
                    bottom: -30px;
                    left: 30px;
                    width: 180px;
                    height: 180px;
                    transform: matrix(-0.97, 0.23, 0.23, 0.97, 0, 0);
                }
            }

            &.youAreTired {
                &:before {
                    background-image: url('../img/icons/zhi-yest.png');
                    top: -40px;
                    right: 70px;
                    width: 180px;
                    height: 180px;
                    transform: rotate(-30.05deg);
                }

                &:after {
                    background-image: url('../img/icons/zhi-yest.png');
                    bottom: -30px;
                    left: 70px;
                    width: 150px;
                    height: 150px;
                    transform: rotate(64.08deg);
                }
            }

            &.datesDoNotOverlap {
                &:before {
                    background-image: url('../img/icons/calendar-tear.png');
                    top: -40px;
                    left: 40px;
                    width: 180px;
                    height: 180px;
                    transform: rotate(-7.06deg);
                }

                &:after {
                    background-image: url('../img/icons/calendar-tear.png');
                    bottom: 50px;
                    right: -25px;
                    width: 120px;
                    height: 120px;
                    transform: rotate(32.28deg);
                }
            }

            &.bitterExperience {
                &:before {
                    background-image: url('../img/icons/letters.png');
                    top: -40px;
                    left: -30px;
                    width: 250px;
                    height: 250px;
                    transform: rotate(-2.71deg);
                }

                &:after {
                    background-image: url('../img/icons/letter-one.png');
                    bottom: 40px;
                    right: -10px;
                    width: 150px;
                    height: 150px;
                    transform: rotate(36.39deg);
                }
            }

            &.everythingIsOk {
                &:before {
                    background-image: url('../img/icons/applause.png');
                    bottom: 50px;
                    left: -20px;
                    width: 220px;
                    height: 220px;
                    transform: rotate(-8.4deg);
                }

                &:after {
                    background-image: url('../img/icons/applause.png');
                    top: -40px;
                    right: 100px;
                    width: 150px;
                    height: 150px;
                    transform: matrix(-0.63, 0.77, 0.77, 0.63, 0, 0);
                }
            }
        }
    }

    @media (max-width: 1100px) {
        .reaction-wrapper {
            .modal-wrapper {
                position: absolute;
                left: 51px;
                top: 45px;
                display: flex;
                align-items: center;
                justify-content: center;
                width: calc(100% - (51px * 2));
                height: calc(100% - (45px * 2));
            }
        }
    }

    @media (max-width: 720px) {
        .reaction-wrapper {
            position: fixed;
            left: 0;
            top: 0;
            width: 100%;
            height: 100%;
            background: #ffffff;
            z-index: 1000;

            .mobile-button {
                position: absolute;
                bottom: 0;
                left: 0;
                display: flex;
                align-items: center;
                text-align: center;
                margin: 16px 20px;
                width: calc(100% - 40px);
                height: 60px;
                font-weight: 700;
                font-size: 18px;
                line-height: 23px;
                color: #FF7100;

                > div {
                    flex: 1;
                }
            }

            .modal-wrapper {
                position: absolute;
                top: 16px;
                left: 0;
                margin: 0 20px;
                display: flex;
                align-items: center;
                justify-content: center;
                width: calc(100% - 40px);
                height: calc(100% - (16px + (16px * 2) + 60px));
                background: #FFFFFF;
                border: 2px solid #FE8324;
                box-sizing: border-box;
                box-shadow: 0px 4px 9px rgba(0, 0, 0, 0.1);
                border-radius: 10px;

                .modal-inner {
                    font-size: 14px;
                    line-height: 24px;
                    margin: 0 25px;
                }

                .close-button {
                    display: none;
                }

                &.lose {
                    &:before {
                        top: unset;
                        bottom: -20px;
                        left: -20px;
                        width: 80px;
                        height: 80px;
                        transform: matrix(-1, 0, 0, 1, 0, 0);
                    }

                    &:after {
                        bottom: unset;
                        top: 100px;
                        right: -15px;
                        width: 35px;
                        height: 35px;
                    }
                }

                &.win {
                    .win-icons {
                        span {
                            &:nth-child(1){
                                top: 25px;
                                left: -10px;
                                width: 20px;
                                height: 20px;
                                transform: unset;
                            }

                            &:nth-child(2){
                                left: 10px;
                                top: -10px;
                                width: 40px;
                                height: 40px;
                                transform: rotate(-13.94deg);
                            }

                            &:nth-child(3){
                                top: 40px;
                                right: -10px;
                                width: 25px;
                                height: 25px;
                                transform: rotate(22.87deg);
                            }

                            &:nth-child(4){
                                top: unset;
                                right: unset;
                                bottom: 135px;
                                left: -10px;
                                width: 30px;
                                height: 30px;
                                transform: rotate(20.13deg);
                            }

                            &:nth-child(5){
                                top: unset;
                                right: unset;
                                bottom: 100px;
                                left: 0px;
                                width: 20px;
                                height: 20px;
                                transform: rotate(47.94deg);
                            }

                            &:nth-child(6){
                                bottom: -25px;
                                right: 10px;
                                width: 50px;
                                height: 50px;
                                transform: rotate(23.56deg);
                            }

                            &:nth-child(7){
                                bottom: 15px;
                                right: -25px;
                                width: 50px;
                                height: 50px;
                                transform: rotate(-24.53deg);
                            }
                        }
                    }
                }


                &.managerDoesntRemember {
                    &:before {
                        width: 100px;
                        height: 100px;
                        top: 50px;
                        right: -10px;
                    }

                    &:after {
                        width: 80px;
                        height: 80px;
                    }
                }

                &.notActualGraph {
                    &:before {
                        top: 50px;
                        right: -20px;
                        width: 70px;
                        height: 70px;
                        transform: rotate(-12.51deg);
                    }

                    &:after {
                        left: -15px;
                        bottom: 30px;
                        width: 100px;
                        height: 100px;
                    }
                }

                &.runOverAll {
                    &:before {
                        left: -15px;
                        top: 30px;
                        width: 100px;
                        height: 100px;
                    }
                    &:after {
                        right: -10px;
                        bottom: 75px;
                        width: 70px;
                        height: 70px;
                    }
                }

                &.youAreLucky {
                    &:before {
                        bottom: 20px;
                    }
                }

                &.hrOneEye {
                    &:before {
                        bottom: 10px;
                        right: -10px;
                        width: 120px;
                        height: 120px;
                    }

                    &:after {
                        top: 40px;
                        left: -5px;
                        width: 80px;
                        height: 80px;
                    }
                }

                &.bossIsAway {
                    &:before {
                        right: -15px;
                        bottom: 50px;
                        width: 120px;
                        height: 120px;
                    }

                    &:after {
                        top: 40px;
                        left: -10px;
                        width: 80px;
                        height: 80px;
                    }
                }

                &.foundAnotherManager {
                    &:before {
                        top: 50px;
                        left: -10px;
                        width: 110px;
                        height: 110px;
                    }

                    &:after {
                        right: -10px;
                        bottom: 50px;
                        width: 100px;
                        height: 100px;
                    }
                }

                &.hrFoundFault {
                    &:before {
                        left: -25px;
                        bottom: 10px;
                        width: 125px;
                        height: 125px;
                        transform: matrix(-1, 0, 0, 1, 0, 0);
                    }

                    &:after {
                        left: unset;
                        right: -20px;
                        top: 20px;
                        width: 100px;
                        height: 100px;
                        transform: matrix(1, 0, 0, -1, 0, 0);
                    }
                }

                &.unpaidLeave {
                    &:before {
                        left: -5px;
                        bottom: -5px;
                        width: 100px;
                        height: 100px;
                    }

                    &:after {
                        top: 70px;
                        right: -15px;
                        width: 35px;
                        height: 35px;
                    }
                }

                &.unpaidLeaveIsOk {
                    &:before {
                        top: unset;
                        right: -5px;
                        width: 120px;
                        height: 120px;
                        bottom: 30px;
                    }

                    &:after {
                        top: 50px;
                        left: -5px;
                        width: 90px;
                        height: 90px;
                    }
                }

                &.youAreTired {
                    &:before {
                        top: unset;
                        bottom: 50px;
                        right: -15px;
                        width: 100px;
                        height: 100px;
                        transform: rotate(-26.32deg);
                    }

                    &:after {
                        bottom: unset;
                        top: 30px;
                        left: -15px;
                        width: 90px;
                        height: 90px;
                        transform: rotate(129.28deg);
                    }
                }

                &.datesDoNotOverlap {
                    &:before {
                        top: unset;
                        bottom: -5px;
                        left: -5px;
                        width: 100px;
                        height: 100px;
                        transform: rotate(-16.15deg);
                    }

                    &:after {
                        bottom: unset;
                        top: 40px;
                        right: -20px;
                        width: 80px;
                        height: 80px;
                        transform: rotate(24.73deg);
                    }
                }

                &.bitterExperience {
                    &:before {
                        top: -10px;
                        left: -15px;
                        width: 150px;
                        height: 150px;
                    }

                    &:after {
                        bottom: 40px;
                        right: -5px;
                        width: 90px;
                        height: 90px;
                    }
                }

                &.everythingIsOk {
                    &:before {
                        bottom: 50px;
                        left: -20px;
                        width: 150px;
                        height: 150px;
                        transform: rotate(-16.31deg);
                    }

                    &:after {
                        top: 50px;
                        right: -20px;
                        width: 150px;
                        height: 150px;
                        transform: matrix(-1, 0.05, 0.05, 1, 0, 0);
                    }
                }
            }
        }
    }
</style>